<template>
  <div class="answering">
    <div>
      <p v-if="message.user.name" class="name">{{ message.user.id !== myself.id ? message.user.name : 'Tú'}}</p>
      <p v-if="message.type === 'text'" style="white-space: pre-wrap;">{{ message.payload.text }} </p> 
      <p v-if="message.type === 'list'"> {{ message.payload.body}} </p>
      <p v-if="message.type === 'quick_reply'"> {{ message.payload.content.text}}</p>
      <p v-else>{{ message.payload.caption ?? message.type }}</p> 
    </div>
    <div v-if="message.type !== 'text'">
      <img :src="message.payload.url" width="50" height="50" v-if="message.type === 'image'">
      <i class="fas fa-play" v-if="message.type === 'audio'"></i>
      <i class="fas fa-file" v-if="message.type === 'file'" ></i>
      <div v-if="message.type === 'video'">
        <img :src="message.payload.previewUrl" width="50" height="50" class="video-thumbnail" v-if="message.payload.previewUrl">
        <video v-else 
          ref="videoElement" 
          width="50" height="50"
          >
          <source :src="message.payload.url" :type="message.payload.contentType" />
        </video>
      </div>
    </div>
  </div>
</template>

<script>
/* import TheMessage from './TheMessage.vue'; */
export default {
  name : "TheAnsweringMessage",
  props : {
    message : {
      required : true
    }
  },
  inject: ['myself'],
  data() {
    return {
      thumbnail : null,
      defaultThumbnail: null,
    }
  },
  methods: {
    captureThumbnail() {
      const video = this.$refs.videoElement;
      const canvas = document.createElement("canvas");
      canvas.width = 100;
      canvas.height = 100;
      const ctx = canvas.getContext("2d");

      video.currentTime = 1; // Intenta capturar el frame en el segundo 1
      setTimeout(() => {
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        this.thumbnail = canvas.toDataURL("image/png"); // Convertir a base64
      }, 200);
    }
  }
}
</script>

<style>
  .answering {
    border-radius: var(--radius);
    display: inline-flex;
    justify-content: space-between;
    font-size: 12px;
    min-width: 300px;
    width: 100%;
    
  }

  .answering button {
    border: none;
    outline: none;
    background: transparent;
  }

  .answering .name {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: calc(var(--column) / 2)
  }

  .answering img {
    object-fit: cover;
    border-radius: 6px;
  }

  .answering p {
    display: -webkit-box;
    -webkit-line-clamp: 3; /* Número de líneas máximo */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
    max-width: 300px;
  }

  .answering i {
    font-size: 32px;
  }
</style>